var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoContainer"},[_c('div',{staticClass:"overlay"}),_c('video',{staticClass:"bg-login",attrs:{"loop":"","autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"https://static.educacionit.com/alumni/assets/bg-login.webm","type":"video/webm"}})]),(_vm.showForm)?_c('login-form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }